/**
 * HomeGroupWA Home Design Page JS Include
 *
 * @author Strange Animals
 */

window.HomeDesignPageObject = function(opts) {
    // OLD JS

    var homedesignpage_obj = $.extend(new window.PageObject({}), {
        showStoreyModal: false,
        type: 0,
        showDesign: false,

        currentDesignID: false,
        currentDesignLink: false,
        currentDesignTitle: false,

        promosShowing: false,

        //page interactivity
        setupOfferEnquiryForm: function() {
            $('#offerenquirebutton').on('click', function(e) {
                $('#TotemForm_GeneralEnquiryForm_Offer').val('No Design Fee Enquiry');
            });

            $('#ContactFormModal').on('hide.bs.modal', function() {
                $('#TotemForm_GeneralEnquiryForm_Offer').val('');
            });
        },

        setupOfferSlideController: function() {
            $('.home-design-content').on('scroll', function(e) {
                if ($(this).scrollTop() < 76) {
                    $('.subheader-enquire').slideDown(200);
                } else {
                    $('.subheader-enquire').slideUp(200);
                }
            });
        },

        checkPromos: function() {
            var actualHeight = $('.promo-banner-image').height();
            var robHeight = actualHeight - 100 + parseInt($('.promo-banner-slide').css('padding-top')) - 3;

            $('.promo-banner-far-left, .promo-banner-left, .promo-banner-right, .promo-banner-solo').css({
                height: actualHeight + 'px',
                width: 'auto'
            });

            $('.promo-banner-far-left').css({
                right: $('.promo-banner-far-left').width() * 2 + 65 + 'px'
            });

            $('.promo-banner-left').css({
                right: $('.promo-banner-left').width() + 40 + 'px'
            });

            if (!this.promosShowing) {
                $('.promo-rob').css('opacity', '1');
                $('.promo-banner-far-left, .promo-banner-left, .promo-banner-right, .promo-banner-solo').css(
                    'opacity',
                    '1'
                );
            }
        },

        filterController: function() {
            var filterBtn = $('.bt-filter');
            var filterElem = $('.filter-form');

            // Event handlers
            filterBtn.unbind('click').on('click', function() {
                if ($(this).hasClass('active')) {
                    filterBtn.removeClass('active');
                    filterElem.removeClass('open');
                } else {
                    filterBtn.addClass('active');
                    filterElem.addClass('open');
                }
            });
        },

        floorplanController: function() {
            var floorplanBtn = $('.bt-floorplan');
            var homeElem = $('.home-design-item .home-design-card');

            // Event handlers
            floorplanBtn.unbind('click').on('click', function() {
                if ($(this).hasClass('active')) {
                    floorplanBtn.removeClass('active');
                    homeElem.removeClass('flip');
                } else {
                    floorplanBtn.addClass('active');
                    homeElem.addClass('flip');
                }
            });
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            var self = this;
            self.setupOfferEnquiryForm();
            self.setupOfferSlideController();
            self.filterController();
            self.floorplanController();
            // self.fixFloorplans();
            setTimeout(function() {
                $('#home-designs-banner')
                    .imagesLoaded()
                    .done(function() {
                        self.checkPromos();
                    });
            }, 2000);

            $('#StoreyModal')
                .on('shown.bs.modal', function(e) {
                    const playPromise = $('#StoreyModal video')[0].play();
                    playPromise.catch(_ => {});
                })
                .on('hide.bs.modal', function(e) {
                    $('#StoreyModal video')[0].pause();
                    Page.layoutPage();
                });

            // Stop video playing when someone clicks a link
            $('.colophon a, .header-logo a, #StoreyModal a').on('click', function() {
                if ($('video')[0]) {
                    $('video')[0].pause();
                }
            });
        },
        onResize: function() {
            this.checkPromos();
        },
        onLoad: function() {
        },
        onChatAgentsOffline: function() {
            this.updateModalLivechatBtn();
        },
        onChatAgentsOnline: function() {
            this.updateModalLivechatBtn();
        },

        updateModalLivechatBtn: function() {
            if (this.livechatAgentAvailable) {
                //$('.home-design-modal').removeClass('livechat-online');
                $('.home-design-modal').removeClass('livechat-offline');
            } else {
                $('.home-design-modal').addClass('livechat-offline');
            }
        },
        updateModalContactData: function(id) {
            if (id) {
                $('.price-enquiry a').data('design', id);
            }
        },
        fixFloorplans: function() {
            setTimeout(function() {
                $('.floorplan-svg').each(function(i, obj) {
                    $("tspan").each(function() {
                        var tspan = $(this);
                        var target = tspan.attr('x');
                        if (typeof target !== 'undefined' && target !== false) {
                            tspan.removeAttr('x');
                        }
                    });
                });
            }, 1000);
        }
    });

    if (opts) {
        return $.extend(homedesignpage_obj, opts);
    } else {
        return homedesignpage_obj;
    }
};
